// extracted by mini-css-extract-plugin
export default {"formError_link":"FormError_formError_link__f5ZQX"};